var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.922 71.4539C99.0777 84.7703 89.8865 96.482 76.3138 101.964C54.5918 110.735 29.8703 100.242 21.0992 78.5196C12.3238 56.7975 22.8215 32.0761 44.5436 23.3049",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.73 59.4144C102.932 62.0651 102.882 64.7032 102.592 67.3034",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.471 48.6312C100.727 49.3664 100.966 50.1099 101.181 50.8492",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1367 41.0027C53.6267 36.0626 63.4774 35.1552 72.068 39.4736C84.8592 45.9007 90.0178 61.4813 83.5906 74.2726C77.1635 87.0639 61.5829 92.2224 48.7916 85.7953",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9902 45.4764C41.7842 44.5775 42.6285 43.7415 43.5275 42.9728",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2637 50.9962C37.5745 50.3829 37.9022 49.7864 38.2508 49.2067",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2623 71.4496C65.067 71.4496 68.962 67.5545 68.962 62.7498C68.962 57.9451 65.067 54.05 60.2623 54.05C55.4575 54.05 51.5625 57.9451 51.5625 62.7498C51.5625 67.5545 55.4575 71.4496 60.2623 71.4496Z",
    fill: "#FD6533"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.52 70.8153C56.0132 75.058 47.8554 66.6271 51.5688 59.0574C52.6274 56.894 54.6648 55.1717 57.0046 54.6802C53.2071 56.957 51.4176 61.6324 53.0727 65.6525C54.6732 69.6979 59.21 71.815 63.5242 70.8153H63.52Z",
    fill: "#FEA183"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9737 93.9237C52.7668 93.9237 56.6524 90.0381 56.6524 85.2449C56.6524 80.4518 52.7668 76.5662 47.9737 76.5662C43.1805 76.5662 39.2949 80.4518 39.2949 85.2449C39.2949 90.0381 43.1805 93.9237 47.9737 93.9237Z",
    fill: "#FFCD3D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2251 93.2935C43.7394 97.5321 35.5983 89.118 39.2992 81.565C40.3578 79.4058 42.391 77.6877 44.7224 77.2004C40.9375 79.473 39.1522 84.1359 40.8031 88.1476C42.3994 92.1803 46.9236 94.2975 51.2251 93.2977V93.2935Z",
    fill: "#FFE7A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1851 36.5499C44.1359 36.5499 48.96 31.7258 48.96 25.7749C48.96 19.8241 44.1359 15 38.1851 15C32.2343 15 27.4102 19.8241 27.4102 25.7749C27.4102 31.7258 32.2343 36.5499 38.1851 36.5499Z",
    fill: "#36CCC1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2201 35.7643C32.9869 40.6792 23.1529 30.5386 27.5847 21.276C28.8491 18.6085 31.3024 16.4787 34.1463 15.7814C29.307 18.4615 26.9756 24.4139 29.0676 29.4548C31.0629 34.5377 36.8768 37.201 42.2201 35.7643Z",
    fill: "#8BE2DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotB);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;